import { ADD_TOAST, REMOVE_TOAST } from "./constants";

let id = 0;
const defaultOptions = {
  kind: "primary",
};

interface ToastMessageOptions {
  kind?: string;
  title?: string;
  message?: string;
  allowHtml?: boolean;
  removalTimeout?: number;
}

export interface ToastMessage {
  id: number;
  kind: string;
  title?: string;
  message?: string;
  allowHtml?: boolean;
  removalTimeout?: number;
}

export const nextId = () => {
  return id++;
};

export const addToast = (options: ToastMessageOptions = {}, id: number) => {
  return {
    type: ADD_TOAST,
    payload: {
      ...defaultOptions,
      ...options,
      id: id,
    },
  };
};

export const removeToast = (id: number) => {
  return {
    payload: id,
    type: REMOVE_TOAST,
  };
};
